"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatter;

var _IAccount = _interopRequireDefault(require("../../../common/iObjects/IAccount"));

function formatter() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLength = arguments.length > 1 ? arguments[1] : undefined;
  var result = value;

  if (value instanceof _IAccount["default"]) {
    result = value.toString('card');
  } else if (value && typeof value === 'string') {
    result = new _IAccount["default"](value.replace(/[\D]/g, '')).toString('card');
  }

  return result ? result.substr(0, maxLength) : result;
}